
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[id]/[slug]",
      function () {
        return require("private-next-pages/events/[id]/[slug].tsx");
      }
    ]);
  